__turbopack_context__.v({
  "fadeInItems": "form-module__QAYc_G__fadeInItems",
  "header": "form-module__QAYc_G__header",
  "loadingIcon": "form-module__QAYc_G__loadingIcon",
  "overlay": "form-module__QAYc_G__overlay",
  "overlayError": "form-module__QAYc_G__overlayError",
  "overlayIntro": "form-module__QAYc_G__overlayIntro",
  "overlayTitle": "form-module__QAYc_G__overlayTitle",
  "spacing--lg": "form-module__QAYc_G__spacing--lg",
  "spacing--md": "form-module__QAYc_G__spacing--md",
  "spacing--sm": "form-module__QAYc_G__spacing--sm",
  "spacing--xl": "form-module__QAYc_G__spacing--xl",
  "spacing--xs": "form-module__QAYc_G__spacing--xs",
  "spacing--xxl": "form-module__QAYc_G__spacing--xxl",
  "spacing--xxs": "form-module__QAYc_G__spacing--xxs",
  "spacing--xxxl": "form-module__QAYc_G__spacing--xxxl",
  "spacing--xxxs": "form-module__QAYc_G__spacing--xxxs",
});
